import React from 'react'
import Container from '../../Container/Container'
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// images
import banner1 from '../../../assets/images/product/banner/banner1.jpg'
import banner2 from '../../../assets/images/product/banner/banner2.jpg'
import banner3 from '../../../assets/images/product/banner/banner3.jpg'
import banner4 from '../../../assets/images/product/banner/banner4.jpg'
import "./FourthBanner.css"

function FourthBanner() {
    return (
        <>
            <Container class1=''>
                <div className="row">
                    <div className="col-12 d-flex justify-content-center">
                        <Swiper
                            spaceBetween={30}
                            autoplay={{
                                delay: 3500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            modules={[Autoplay, Pagination, Navigation]}
                            className="mySwiper banner_swiper bdrs20 col-12 "
                        >
                            <SwiperSlide><img src={banner1} className='img-fluid w-100' alt="" /></SwiperSlide>
                            <SwiperSlide><img src={banner2} className='img-fluid w-100' alt="" /></SwiperSlide>
                            <SwiperSlide><img src={banner3} className='img-fluid w-100' alt="" /></SwiperSlide>
                            <SwiperSlide><img src={banner4} className='img-fluid w-100' alt="" /></SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default FourthBanner